import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { MaterialHeader } from "./MaterialHeader";
import MaterialContent from "./MaterialContent";
import { Row } from "reactstrap";


const MaterialGenBox = ({
  data,
}) => {

  return (
    <div className={`dashboard-wrapper bg-none`}>
      <div>
      <div className={` row px-5`}>
            <div className={`sm-py-1 px-0`}>
              <div className="py-4 min-h-84 quiz-detail-width">
              <div id="scroll" className={`question_scroll`}>
                        <div className="Question__description">
                            <MaterialHeader
                                data={data}
                            />
                            <Row className="border bg-white border-top-0 border-bottom-0 px-4 py-3 fs-14">
                                <div>
                                <MaterialContent
                                    data={data}
                                    genBox={true}
                                />
                                </div>
                            </Row>
                        </div>
                    </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
};

export default MaterialGenBox;
